import React, { lazy } from 'react';
import { motion } from 'framer-motion';
export function WhyChooseUs() {
  return <section className="w-full bg-white py-24 px-6 md:px-12 overflow-hidden" data-id="element-262">
      <div className="max-w-7xl mx-auto relative" data-id="element-263">
        {/* Large Title - overlaps image */}
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.8
      }} className="relative z-10 mb-0" data-id="element-264">
          <h2 className="text-7xl md:text-[9rem] lg:text-[11rem] font-bebas text-[#1a2744] leading-[0.85] tracking-wide" data-id="element-265">
            WHY
            <br data-id="element-266" />
            CHOOSE
            <br data-id="element-267" />
            US?
          </h2>
        </motion.div>

        {/* Main Image - pulled up so title overlaps */}
        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.8,
        delay: 0.2
      }} className="w-full h-[400px] md:h-[600px] relative z-0 -mt-16 md:-mt-28 lg:-mt-36" data-id="element-268">
          <img src="https://cdn.magicpatterns.com/uploads/6v87pvNHWsCBGVQJNxfGZy/sj-website-home-img5.png" alt="Beautifully clean living room by Smith and Jengs professional cleaners" className="w-full h-full object-cover" loading="lazy" data-id="element-269" />
        </motion.div>

        {/* Info Card Overlay - white/cream, bottom-left */}
        <motion.div initial={{
        opacity: 0,
        y: 50
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.8,
        delay: 0.4
      }} className="relative z-10 -mt-32 md:-mt-48 flex flex-col md:flex-row items-end gap-8" data-id="element-270">
          <div className="bg-white/95 backdrop-blur-sm p-8 md:p-10 max-w-xl shadow-sm" data-id="element-271">
            <p className="text-sm md:text-base text-[#1a2744] leading-relaxed mb-6" data-id="element-272">
              We deliver The Best Cleaning Service and back it up with a 100%
              Satisfaction Guarantee. Our whole team is professionally trained,
              vetted, and insured. All you need to do is book a residential maid
              cleaning or commercial cleaning service and then make time for
              what matters most – YOU! Enjoy your day and we'll take care of the
              rest.
            </p>
            <p className="text-sm italic text-gray-500" data-id="element-273">
              But there's a whole lot more to us...
              <br data-id="element-274" />
              Such as our superlative customer care and innovation.
            </p>
          </div>

          <div className="flex items-center gap-4 pb-2 ml-auto" data-id="element-275">
            <span className="font-semibold text-[#1a2744] text-sm tracking-wide" data-id="element-276">
              Book Online
            </span>
            <button className="w-12 h-12 rounded-full border border-[#1a2744] flex items-center justify-center hover:bg-[#1a2744] hover:text-white transition-colors group" data-id="element-277">
              <span className="transform group-hover:translate-x-1 transition-transform text-[#1a2744] group-hover:text-white" data-id="element-278">
                &rarr;
              </span>
            </button>
          </div>
        </motion.div>
      </div>
    </section>;
}